export const screenNames = {
  NONE: "none",
  AUTH_METHODS: "auth-methods",
  PASSWORDLESS: "passwordless",
  LOGIN_SYNC: "login-sync",
  SIGNIN: "login",
  SIGNUP: "create-account",
  FORGOT_PASSWORD: "reset-password",
  RESET_PASSWORD: "reset-password",
  SUCCESS: "success",
  CUSTOM_INITIAL: "custom-initial",
  CUSTOM_SUCCESS: "custom-success",
} as const;
